var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavyUpLightGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1438,
    height: 295,
    viewBox: "0 0 1438 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-34 0.700195L-3.33333 17.0502C27.3333 33.4002 88.6667 66.1002 150 77.0342C211.333 87.5596 272.667 77.3408 334 98.8002C395.333 120.26 456.667 175.441 518 175.134C579.333 175.441 640.667 120.26 702 126.084C763.333 131.5 824.667 196.9 886 191.484C947.333 185.66 1008.67 110.041 1070 82.4502C1131.33 54.8596 1192.67 77.3408 1254 82.4502C1315.33 87.5596 1376.67 77.3408 1407.33 71.5161L1438 66.1002V295H1407.33C1376.67 295 1315.33 295 1254 295C1192.67 295 1131.33 295 1070 295C1008.67 295 947.333 295 886 295C824.667 295 763.333 295 702 295C640.667 295 579.333 295 518 295C456.667 295 395.333 295 334 295C272.667 295 211.333 295 150 295C88.6667 295 27.3333 295 -3.33333 295H-34V0.700195Z",
    fill: "#E7EDFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyUpLightGray);
export default __webpack_public_path__ + "static/media/wavy_up_lightGray.8827b9ff97f3538e937966d69d7fbc69.svg";
export { ForwardRef as ReactComponent };